import { FormFieldSettings } from './types';

export const formFieldSettings: FormFieldSettings = {
  componentVariants: {
    labelPosition: {
      prop: 'labelPosition',
      variants: {
        left: {
          columnGap: 4,
          flexDirection: 'row',
        },
        top: {
          rowGap: 2,
          flexDirection: 'column',
        },
      },
    },
  },
};
